var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcode-vue',{attrs:{"value":decodeURIComponent(_vm.uri),"size":_vm.size,"level":"H"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }